import { createContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { api } from "../services/api";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [username, setUserName] = useState();

  const UserEPasswordOK = () => toast.success("Logando.....");
    const UserIncorrectNot = () =>
    toast.warning("Usuário ou Senha inválido");
  
  useEffect(() => {
    const loadingStoreData = () => {
      const storageUser = sessionStorage.getItem("@Auth:user");
      const storageToken = sessionStorage.getItem("@Auth:token");

  if (storageUser && storageToken) {
        setUserName(storageUser);
  }
    };
    loadingStoreData();
  }, []);

  const signIn = async ({ username, password }) => {

    if (username?.length === null && password?.length === null ) {
      if (username[0].username === username && username[0].password === password) {
        setUserName({ username, password });
        return;
      } else { 
        UserEPasswordOK();
      }
    } else {

    }

    try {
      const response = await api.post(
        "/login",
        { username, password },
        {
          headers: {
            appKey:
              "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (response.data.error) { 
        alert(response.data.error);
      } else {
        
        setUserName(response.data);
        
        api.defaults.headers.common[
          // eslint-disable-next-line no-sequences
          "Authorization"
        ] = `Bearer ${response.data.token}`;
        
        sessionStorage.setItem("@Auth:data", JSON.stringify(response.data));
        sessionStorage.setItem("@Auth:user", JSON.stringify(username));
        sessionStorage.setItem("@Auth:token", response.data.token);
      }
    } catch (error) {
      UserIncorrectNot();  
      console.log(error);      
    }
  };

  const singOut = () => {
    sessionStorage.clear();
    setUserName(null);
    return <Navigate to="/esat/sigecap/" />;
  };

  return (
    <AuthContext.Provider
      value={{
        username,
        signIn,
        singOut,
        signed: !!username,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
